var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "module dt-epitasis" },
    [
      _vm.show
        ? [
            _c(
              "h3",
              [
                _vm._v("\n      剧情\n      "),
                _vm.kvFinishEp && _vm.kvFinishEp > 4 && false
                  ? [
                      _vm.kvFinishEp >= _vm.entity_finish_ep
                        ? _c("span", [
                            _vm._v(
                              " 共" + _vm._s(_vm.entity_finish_ep) + "集 "
                            ),
                          ])
                        : _c("span", [
                            _vm._v("更新至第" + _vm._s(_vm.kvFinishEp) + "集"),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dt-epitasis-wrap" }, [
              _c(
                "ul",
                { staticClass: "dt-epitasis-list" },
                [
                  _vm._l(_vm.plot, function (v, index) {
                    return _c("li", { key: index }, [
                      index < 4
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/summary/plot?key=" +
                                  _vm.dockey +
                                  "&ep=" +
                                  v.ep +
                                  "&spver=" +
                                  _vm.spver,
                                uigs: "epitasis_" + v.ep,
                              },
                            },
                            [
                              _c("p", { staticClass: "tit" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.showNumbStyle
                                      ? "第" + v.ep + "集"
                                      : v.title
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.formatString(v.content))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _c("li", [
                    _vm.kvFinishEp && _vm.kvFinishEp > 4
                      ? _c(
                          "a",
                          {
                            staticClass: "more",
                            attrs: {
                              href:
                                "/summary/plot?key=" +
                                _vm.dockey +
                                "&spver=" +
                                _vm.spver,
                            },
                          },
                          [_vm._v("更多")]
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }